import {Component, ElementRef, Input} from '@angular/core';
import {kanUsersService} from "../../../../services/services/users";
import {MatDialog, PageEvent} from "@angular/material";
import {Dog} from "../../../../../classes/dog";
import {kanDogsService} from "../../../../services/services/dogs";
import {kanDogDialog} from "../../../dialogs/dog-dialog/component";
import {User} from "../../../../../classes/user";
import {MembershipType} from "../../../../../classes/membershipType";
import {kanMembershipService} from "../../../../services/services/membership";

@Component({
    selector: 'kan-renewal',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    providers: [kanUsersService]
})
export class kanRenewal {

    @Input() public selectedTab: number;
    public loading: boolean = false;
    public dogs: Dog[];
    public search: string = '';
    public sortBy: string = 'nameOrder';
    public sortByOptions: any[] = [
        {
            title: 'NAME',
            field: 'nameOrder'
        },
        {
            title: 'RACE',
            field: 'race'
        },
        {
            title: 'OWNER',
            field: 'ownerOrder'
        }];
    public sortDirection: string = 'ASC';
    public sortDirections: string[] = ['ASC', 'DESC'];
    public fromDate: Date;
    public toDate: Date;
    public minDate: Date;
    public membershipTypes: MembershipType[] = [];
    public selectedMembershipType: string = '';
    public pageIndex: number = 0;
    public pageSize: number = 20;
    public totalDogs: number = 0;
    private filter: any;
    public timeout: any;
    public selectedMonth: number = new Date().getMonth();
    public months: any[] = [
        {
            label: 'Enero',
            value: 0
        },
        {
            label: 'Febrero',
            value: 1
        },
        {
            label: 'Marzo',
            value: 2
        },
        {
            label: 'Abril',
            value: 3
        },
        {
            label: 'Mayo',
            value: 4
        },
        {
            label: 'Junio',
            value: 5
        },
        {
            label: 'Julio',
            value: 6
        },
        {
            label: 'Agosto',
            value: 7
        },
        {
            label: 'Septiembre',
            value: 8
        },
        {
            label: 'Octubre',
            value: 9
        },
        {
            label: 'Noviembre',
            value: 10
        },
        {
            label: 'Diciembre',
            value: 11
        }
    ];
    public year: number = new Date().getFullYear();

    constructor(private element: ElementRef,
                private dialog: MatDialog,
                private dogsService: kanDogsService,
                private membershipService: kanMembershipService) {
    }

    ngOnInit(): void {
        this.setDates();

        this.filter = {
            where: {
                and: [
                    {
                        or: [
                            {
                                active: true,
                                membershipActive: true,
                                membershipRenewalDate: {
                                    lt: this.toDate
                                }
                            },
                            {
                                active: true,
                                membershipActive: true,
                                membershipRenewalDate: null
                            }
                        ]
                    },
                    {
                        or: [
                            {
                                active: true,
                                membershipActive: true,
                                membershipRenewalDate: {
                                    gt: this.fromDate
                                }
                            },
                            {
                                active: true,
                                membershipActive: true,
                                membershipRenewalDate: null
                            }
                        ]
                    }
                ]
            },
            order: `${this.sortBy} ${this.sortDirection}`,
            skip: 0,
            limit: 20,
            include: ['owner', 'membershipType']
        };
    }

    ngOnChanges(changes): void {
        if (changes.selectedTab.currentValue === 1) {
            this.getDogs();
            this.getMembershipTypes();
        }
    }

    public getDogs(): void {
        this.loading = true;
        this.dogsService.countDogs(this.filter.where)
            .then((count) => {
                this.totalDogs = count;
                return this.dogsService.getDogs(this.filter);
            })
            .then((dogs: Dog[]) => {
                this.dogs = dogs;
                this.loading = false;
                this.element.nativeElement.querySelector('.kan-dogs-admin-container').scrollTop = 0;
            })
            .catch((error) => {
                console.log(error);
                this.loading = false;
            });
    }

    public getMembershipTypes(): void {
        this.membershipService.getTypes()
            .then((membershipTypes: MembershipType[]) => {
                this.membershipTypes = membershipTypes;
            })
            .catch((error: any) => {
                console.log(error);
            });
    }

    public changeDate(event) {
        if (!this.toDate) {
            this.toDate = new Date();
            this.toDate.setHours(23, 59, 59);
        }

        this.setFilter();
    }

    public setDates() {
        this.fromDate = new Date();
        this.fromDate.setFullYear(this.year);
        this.fromDate.setMonth(this.selectedMonth);
        this.fromDate.setDate(1);
        this.fromDate.setHours(0, 0, 0);

        this.toDate = new Date();
        this.toDate.setFullYear(this.year);
        this.toDate.setMonth(this.selectedMonth + 1);
        this.toDate.setDate(1);
        this.toDate.setHours(0, 0, 0);
    }


    public changePage(event: PageEvent) {
        this.pageIndex = event.pageIndex;
        this.pageSize = event.pageSize;
        this.filter.skip = this.pageIndex * this.pageSize;
        this.filter.limit = this.pageSize;
        this.getDogs();
    }

    public setFilter() {
        clearTimeout(this.timeout);
        this.loading = true;
        this.pageIndex = 0;
        this.filter.skip = this.pageIndex * this.pageSize;
        this.filter.limit = this.pageSize;
        this.filter.order = `${this.sortBy} ${this.sortDirection}`;
        this.setDates();

        this.filter.where = {
            and: [
                {
                    or: [
                        {
                            active: true,
                            membershipActive: true,
                            membershipRenewalDate: {
                                lt: this.toDate
                            }
                        },
                        {
                            active: true,
                            membershipActive: true,
                            membershipRenewalDate: null
                        }
                    ]
                },
                {
                    or: [
                        {
                            active: true,
                            membershipActive: true,
                            membershipRenewalDate: {
                                gt: this.fromDate
                            }
                        },
                        {
                            active: true,
                            membershipActive: true,
                            membershipRenewalDate: null
                        }
                    ]
                }
            ]
        };


        if (this.selectedMembershipType) {
            this.filter.where.and.push({membershipTypeId: this.selectedMembershipType});
        }

        if (this.search.trim()) {
            let fields = ['name', 'race', 'ownerName'];
            this.search.trim().split(/\s+/)
                .forEach((s) => {
                    let andBlock = {
                        or: []
                    };
                    s = s.replace(/[aäàá]/g, '[aäàá]')
                        .replace(/[eëéè]/g, '[eëéè]')
                        .replace(/[iïíì]/g, '[iïíì]')
                        .replace(/[oöóò]/g, '[oöóò]')
                        .replace(/[uüúù]/g, '[uüúù]')
                        .replace(/\./g, '\\.');
                    let regexp = `.*(${s}|${s.toUpperCase()}).*`;
                    fields.forEach((field) => {
                        let orBlock = {};
                        orBlock[field] = {
                            regexp: regexp
                        };
                        andBlock.or.push(orBlock);
                    });
                    this.filter.where.and.push(andBlock);
                });
        }
        this.timeout = setTimeout(() => {
            this.getDogs();
        }, 800);
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/dog/renewal/component.ts